//import "./safetyforms.css";
import moment from "moment";
import { useContext, useEffect } from "react";
import "react-dropdown/style.css";
import { formatPhoneNumber } from "react-phone-number-input";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import ur1 from "../assets/ur1.png";
import { fetchDailyReport, selectActiveReport, selectDailyReportById, setActive } from "../common/slices/dailyreport";
import { selectActiveLocation } from "../common/slices/location";
import Layout, { Content } from "./Layout";
import MediaPreview from "./MediaPreview";
import Row from "./Row";
import SidebarDailyReport from "./SidebarDailyReport";
import { P, P2 } from "./Typography";
import * as _ from 'lodash';
import { ErrorContext } from "../ErrorContext";
import Modal from "./Modal";
import { pathNames } from "../constants";
import theme from "../common/theme";

const questions = [
    {
        "heading": "Safety Forms / Hazard ID",
        "types": [],  //Empty means all inspection types
        "questions": [
            {
                "title": "FLHA completed and signed",
                "types": []
            },
            {
                "title": "Valid permit (ie. hot work, confined space)",
                "types": []
            }
        ]
    },
    {
        "heading": "Work Area / Site Conditions",
        "types": [],
        "questions": [
            {
                "title": "General housekeeping is maintained",
                "types": [],
            },
            {
                "title": "Control zone / fencing set up",
                "types": [],
            },
            {
                "title": "Good ventilation",
                "types": ["TRAFFIC_COATING", "SITE_SAFETY"],
            },
        ]
    },
    {
        "heading": "PPE",
        "types": [],
        "questions": [
            {
                "title": "Basic PPE worn and good condition",
                "types": [],
            },
            {
                "title": "Task-specific PPE worn",
                "types": [],
            },
            {
                "title": "Workers dressed appropriately for weather",
                "types": [],
            },
        ]
    },
    {
        "heading": "Emergency Preparedness",
        "types": [],
        "questions": [
            {
                "title": "Safety box present and stocked with first aid kit, eye wash, spill kit at minimum",
                "types": [],
            },
            {
                "title": "Fire extinguishers present, appropriate quantity, inspected",
                "types": [],
            },
        ]
    },
    {
        "heading": "Fall Protection",
        "types": [],
        "questions": [
            {
                "title": "Fall Protection Plan completed and signed",
                "types": [],
            },
            {
                "title": "Personal PPE inspected, worn correctly",
                "types": [],
            },
            {
                "title": "Fall arrest / travel restraint system setup correctly",
                "types": [],
            },
            {
                "title": "Guardrails set up correctly",
                "types": [],
            },
            {
                "title": "Tools tethered appropriately",
                "types": [],
            },
        ]
    },
    {
        "heading": "Hot Work / Torching",
        "types": ["WATERPROOFING", "ROOFING", "SITE_SAFETY"],
        "questions": [
            {
                "title": "Fire extinguishers located within 10' of torcher",
                "types": [],
            },
            {
                "title": "Propane secured",
                "types": [],
            },
            {
                "title": "Torches, hoses, regulators in good condition",
                "types": [],
            },
        ]
    },
    {
        "heading": "Kettle",
        "types": ["WATERPROOFING", "SITE_SAFETY"],
        "questions": [
            {
                "title": "Safe location + setup, clear work area, clear walkway",
                "types": [],
            },
            {
                "title": "Condition of kettle, parts, and trailer",
                "types": [],
            },
            {
                "title": "Propane secured, fire extinguisher / powder nearby",
                "types": [],
            },
        ]
    },
    {
        "heading": "Confined Space",
        "types": ["WATERPROOFING", "SITE_SAFETY"],
        "questions": [
            {
                "title": "Rescue plan created, clear communication method",
                "types": [],
            },
            {
                "title": "Air quality monitors used, calibrated",
                "types": [],
            },
            {
                "title": "Correct set up of rescue device",
                "types": [],
            },
            {
                "title": "Sufficient ventilation / air movement",
                "types": [],
            },
        ]
    },
    {
        "heading": "Tools / Equipment",
        "types": [],
        "questions": [
            {
                "title": "Hand / power tools in good condition, guards in place",
                "types": [],
            },
            {
                "title": "Extension cords in good condition",
                "types": [],
            },
            {
                "title": "Gas / diesel-powered equipment in good condition",
                "types": [],
            },
        ]
    },
    {
        "heading": "Materials Securement / Waste Management",
        "types": [],
        "questions": [
            {
                "title": "Materials secured",
                "types": [],
            },
            {
                "title": "Waste secured / disposed of appropriate",
                "types": [],
            },
            {
                "title": "Waste dry before disposal",
                "types": ["TRAFFIC_COATING", "SITE_SAFETY"],
            },
        ]
    },
    {
        "heading": "Ladders / Scaffolding",
        "types": [],
        "questions": [
            {
                "title": "Correct ladder selected and set up correctly, and secured",
                "types": [],
            },
            {
                "title": "3-point contact observed",
                "types": [],
            },
            {
                "title": "Scaffold has valid inspection tag (21 days)",
                "types": [],
            },
        ]
    },
    {
        "heading": "Environmental",
        "types": [],
        "questions": [
            {
                "title": "Fuel / oil stored in spill tray or per site rules",
                "types": [],
            },
            {
                "title": "Gas / diesel-powered equipment kept on spill tray or per site rules",
                "types": [],
            },
            {
                "title": "Spill kit present and stocked",
                "types": [],
            },
        ]
    },
    {
        "heading": "Mobile Equipment",
        "types": [],
        "questions": [
            {
                "title": "Inspected, good condition",
                "types": [],
            },
            {
                "title": "Firm / level ground, no obstacles around or above",
                "types": [],
            },
            {
                "title": "Control zone set up",
                "types": [],
            },
        ]
    },
]


const Logo = styled.img`
    height: 65px;
`

const ReportContainer = styled.div`
    display: flex;
    flex-direction: column;
    background-color: white;
    align-self: center;
    width: 825px;
    padding: 3rem 4rem;
    flex: 1;
`

const ReportSectionHeader = styled.div`
    background-color: black;
    color: white;
    margin: 1rem 0;
    padding: 0.25rem 1rem;
    font-weight: 500;
`

const ReportSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`

const MediaSection = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
    flex: 1;
`

const Attribute = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`

const MediaContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: calc(50% - 0.5rem);
`

const Signature = styled.img`
    objectFit: contain;
    width: 200px;
`

const ReportMedia = ({ media }) => {
    return (
        <MediaContainer>
            <MediaPreview value={media} style={{ flex: 1 }} imgStyle={{ aspectRatio: 1, objectFit: 'cover' }} />
            <Attribute>
                <P2>Notes</P2>
                <P>{media?.description}</P>
            </Attribute>
        </MediaContainer>
    )
}

const getValue = (v) => {
    switch (v) {
        case true:
            return 'Yes';
        case undefined:
            return 'NA';
        case false:
            return 'No';
        default:
            return 'NA';
    }
}

const DailyReport = ({ report }) => {
    const location = useSelector(selectActiveLocation);

    return (
        <ReportContainer id="report-container">
            <Row>
                <Logo src={ur1} />
                <div style={{ display: "flex", flex: 1, justifyContent: 'flex-end', flexDirection: "column", textAlign: 'right' }}>
                    <P2>{location?.name}</P2>
                    <P>{location?.address}</P>
                    {location?.address1 && <P>{location?.address1}</P>}
                    <P>{location?.province} {location?.postalCode}</P>
                    <P>{formatPhoneNumber(location?.phoneNumber)}</P>
                </div>
            </Row>
            <ReportSectionHeader>{report?.type === 'DAILY_REPORT' ? 'Foreman Daily Production Report' : `${_.capitalize(report?.inspectionType)} Inspection Report`}</ReportSectionHeader>
            <ReportSection>
                <Attribute>
                    <P2>Date</P2>
                    <P>{moment(report?.submissionDate).format("YYYY-MM-DD [at] h:mm A")}</P>
                </Attribute>
                <Row>
                    <Attribute>
                        <P2>Customer</P2>
                        <P>{report?.customer?.name ?? report?.customerName}</P>
                    </Attribute>
                    {
                        report?.type === 'INSPECTION' && report?.address &&
                        <Attribute>
                            <P2>Address</P2>
                            <P>{report?.address}</P>
                        </Attribute>
                    }
                </Row>
                {
                    report?.type === 'SAFETY' &&
                    <>
                        <Attribute>
                            <P2>Weather</P2>
                            <P>{report?.weather}</P>
                        </Attribute>
                        <Attribute>
                            <P2>Task, Work Area</P2>
                            <P>{report?.taskArea}</P>
                        </Attribute>
                    </>
                }
                <Row>
                    {
                        report?.type === 'SAFETY' &&
                        <Attribute>
                            <P2>Foreman Name</P2>
                            <P>{report?.foremanName}</P>
                        </Attribute>
                    }
                    <Attribute>
                        <P2>Completed By</P2>
                        <P>{report?.foreman?.name}</P>
                    </Attribute>
                </Row>
            </ReportSection>

            {
                report?.type === 'SAFETY' &&
                <>
                    <ReportSectionHeader>Inspection Items</ReportSectionHeader>
                    {
                        questions
                            .filter(q => !q.types.length || q.types.includes(report?.inspectionType))
                            .map((q, i) => (
                                <Row style={{ alignItems: 'flex-start', paddingBottom: '1rem' }}>
                                    <P style={{ fontWeight: 700, width: '25%' }}>{q.heading}</P>
                                    <div style={{ flex: 1 }}>
                                        {
                                            q.questions
                                                .filter(q1 => !q1.types.length || q1.types.includes(report?.inspectionType))
                                                .map((q1, j) => (
                                                    <Row style={{ borderBottom: '1px solid #cdcdcd' }}>
                                                        <P style={{ marginRight: 'auto' }}>{q1.title}</P>
                                                        <P>{getValue(report?.inspectionQuestion?.[i]?.[j])}</P>
                                                    </Row>
                                                ))
                                        }
                                    </div>
                                </Row>
                            ))
                    }
                    {report?.correctiveActions?.length > 0 && <ReportSectionHeader>Corrective Actions</ReportSectionHeader>}
                    {
                        report?.correctiveActions?.map(ca => (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                                <Attribute>
                                    <P2>Action</P2>
                                    <P>{ca.action}</P>
                                </Attribute>
                                <Row style={{ paddingBottom: '1rem', alignItems: 'flex-start' }}>
                                    <Attribute>
                                        <P2>Assigned To</P2>
                                        <P>{ca.assignedTo}</P>
                                    </Attribute>
                                    <Attribute>
                                        <P2>Due Date</P2>
                                        <P>{moment(ca.dueDate).format('MMMM D YYYY')}</P>
                                    </Attribute>
                                    <Signature src={ca.signature} />
                                </Row>
                            </div>
                        ))
                    }
                </>
            }

            <ReportSectionHeader>Notes</ReportSectionHeader>
            <P dangerouslySetInnerHTML={{ __html: report?.summary?.replaceAll('\n', '<br />') }} />

            <ReportSectionHeader>Information</ReportSectionHeader>
            {
                report?.type === 'DAILY_REPORT' &&
                <ReportSection>
                    <Row>
                        <Attribute>
                            <P2>QA-QC Completed?</P2>
                            <P>{report?.qaqcCompleted ? 'Yes' : 'No'}</P>
                        </Attribute>
                        <Attribute>
                            <P2>Site was left secured and materials secured?</P2>
                            <P>{report?.siteSecured ? 'Yes' : 'No'}</P>
                        </Attribute>
                        <Attribute>
                            <P2>Anyone Injured?</P2>
                            <P>{report?.anyoneInjured ? 'Yes' : 'No'}</P>
                        </Attribute>
                    </Row>
                </ReportSection>
            }
            {
                report?.type === 'DAILY_REPORT' &&
                <ReportSectionHeader>Media</ReportSectionHeader>
            }
            <MediaSection>
                {_.orderBy(report?.media?.items, 'sortKey').map(media => (
                    <ReportMedia media={media} key={media.id} />
                ))}
            </MediaSection>

            {
                (report?.foremanSignature || report?.safetySignature) &&
                <ReportSectionHeader />
            }
            <Row>
                {
                    report?.foremanSignature &&
                    <Attribute>
                        <P2>Foreman Signature</P2>
                        <Signature src={report?.foremanSignature} />
                    </Attribute>
                }
                {
                    report?.safetySignature &&
                    <Attribute>
                        <P2>Safety Signature</P2>
                        <Signature src={report?.safetySignature} />
                    </Attribute>
                }
            </Row>

        </ReportContainer>
    )
}


const PreviewDailyReport = ({ id }) => {
    const errorContext = useContext(ErrorContext);
    const dispatch = useDispatch();
    const report = useSelector(selectActiveReport);
    const nav = useNavigate();

    useEffect(() => {
        //Reset the state when the modal closes
        return () => dispatch(setActive(null));
    }, [])

    useEffect(() => {
        (async () => {
            try {
                if (id) {
                    await dispatch(fetchDailyReport(id));
                }
            } catch (ex) {
                errorContext.setError({ errorMessage: "Failed to fetch report.", forSupport: ex.message })
            }
        })()
    }, [id, dispatch]);

    return (
        <Modal show bodyStyle={{ height: '90%' }} onClose={() => nav(pathNames.DAILYREPORT)} closeOnEscape>
            <div style={{ flex: 1, display: "flex", flexDirection: "row", maxHeight: '100%' }}>
                <SidebarDailyReport report={report} />
                <Content style={{ backgroundColor: "#d9d9d9", padding: '1rem', overflowY: 'auto' }}><DailyReport report={report} /></Content>
            </div>
        </Modal>
    );
};
export default PreviewDailyReport;
